import { Component, Output, EventEmitter, ElementRef } from '@angular/core';
/**
 * <p>CfDatatablePager component is used to generate datatable pagination</p>
 * <pre>
 * <code>
 * <code><</code>cf-datatable-pager<code>></code><code><</code><code>/</code>cf-datatable-pager<code>></code>
 * </code>
 * </pre>
 */
export class CfDatatablePagerComponent {
/**
 * @hidden 
 * Event emitted with page number on page switch
 */
onPageSwitch = new EventEmitter();
/**
 * @hidden
 */
_rowsCount = 0;
/**
 * @hidden
 */
_perPage = 1;
/**
 * @hidden
 */
_current = 1;
/**
 * @hidden
 */
_pages = [];
/**
 * @hidden
 * @return {?}
 */
get _totalPages(): number {
    const /** @type {?} */ _rowsCount = this._perPage < 1 ? 1 : Math.ceil(this._rowsCount / this._perPage);
    return Math.max(_rowsCount || 0, 1);
  }
/**
 * @hidden
 * @return {?}
 */
get _isVisible(): boolean { return (this._rowsCount / this._perPage) > 1; }
/**
 * @hidden 
 * If pager has previous pages according to current page
 * @return {?}
 */
_canBack() { return this._current > 1; }
/**
 * @hidden 
 * If pager has next pages according to current page
 * @return {?}
 */
_canNext() { return this._current < this._totalPages; }
/**
 * @hidden 
 * Go to previous page
 * @return {?}
 */
_prevPage() { this._selectPage(this._current - 1); }
/**
 * @hidden 
 * Go to next page
 * @return {?}
 */
_nextPage() { this._selectPage(this._current + 1); }
/**
 * @hidden 
 * Go to page
 * @param {?} page  page number
 * @return {?}
 */
_selectPage(page: number) {
    if (page > 0 && page <= this._totalPages && page !== this._current) {
      this._current = page;
      this.onPageSwitch.emit({ page });
      this._calcPages();
    }
  }
/**
 * @hidden 
 * Go to page
 * @param {?=} page  page number
 * @return {?}
 */
_calcPages(page?: number) {
    const /** @type {?} */ pages = [];
    let /** @type {?} */ startPage = 1;
    let /** @type {?} */ endPage = this._totalPages;
    const /** @type {?} */ maxSize = 5;
    const /** @type {?} */ isMaxSized = maxSize < this._totalPages;
    page = page || this._current;
    if (isMaxSized) {
      startPage = ((Math.ceil(page / maxSize) - 1) * maxSize) + 1;
      endPage = Math.min(startPage + maxSize - 1, this._totalPages);
    }
    for (let /** @type {?} */ num = startPage; num <= endPage; num++) {
      pages.push({ number: num, text: num });
    }
    this._pages = [...pages];
  }
/**
 * @hidden 
 * Method to be used by CfDatatableComponent to synchronize its data with pager
 * @param {?} rows  rows length
 * @param {?} perPage  rows length per page
 * @param {?=} page  current page number
 * @return {?}
 */
_updatePager(rows: number, perPage: number, page?: number) {
    this._rowsCount = rows;
    this._perPage = perPage;
    this._calcPages();
    if (typeof page === 'number') { this._selectPage(page); }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-datatable-pager',
  template: "<div [hidden]=\"!_isVisible\">   <ul class=\"pager\"> <li [class.disabled]=\"!_canBack()\"> <a href=\"javascript:void(0)\" (click)=\"_selectPage(1)\"> <i class=\"datatable-icon-prev\"></i> </a> </li> <li [class.disabled]=\"!_canBack()\"> <a href=\"javascript:void(0)\" (click)=\"_prevPage()\"> <i class=\"datatable-icon-left\"></i> </a> </li> <li class=\"pages\" *ngFor=\"let pg of _pages\" [class.active]=\"pg.number === _current\"> <a href=\"javascript:void(0)\" (click)=\"_selectPage(pg.number)\">{{pg.text}}</a> </li> <li [class.disabled]=\"!_canNext()\"> <a href=\"javascript:void(0)\" (click)=\"_nextPage()\"> <i class=\"datatable-icon-right\"></i> </a> </li> <li [class.disabled]=\"!_canNext()\"> <a href=\"javascript:void(0)\" (click)=\"_selectPage(_totalPages)\"> <i class=\"datatable-icon-skip\"></i> </a> </li> </ul> </div>",
  styles: [":host { margin: 0 10px; } :host .pager, :host .pager li { padding: 0; margin: 0; display: inline-block; list-style: none; vertical-align: middle; } :host .pager li, :host .pager li a { outline: none; } :host .pager li a { height: 22px; min-width: 24px; line-height: 22px; padding: 0 6px; border-radius: 3px; margin: 6px 3px; text-align: center; vertical-align: top; color: rgba(0, 0, 0, 0.54); text-decoration: none; vertical-align: bottom; cursor: pointer; display: inline-block; box-sizing: border-box; } :host .pager li a:hover { color: rgba(0, 0, 0, 0.75); background-color: rgba(158, 158, 158, 0.2); } :host .pager li.active a { font-weight: bold; background-color: rgba(158, 158, 158, 0.2); } :host .pager li.disabled a { color: rgba(0, 0, 0, 0.26) !important; background-color: transparent !important; cursor: not-allowed; } :host .datatable-icon-left, :host .datatable-icon-skip, :host .datatable-icon-right, :host .datatable-icon-prev { font-size: 20px; line-height: 20px; padding: 0 3px; } "],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onPageSwitch': [{ type: Output },],
};
}

function CfDatatablePagerComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfDatatablePagerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfDatatablePagerComponent.ctorParameters;
/** @type {?} */
CfDatatablePagerComponent.propDecorators;
/**
 * @hidden 
 * Event emitted with page number on page switch
 * @type {?}
 */
CfDatatablePagerComponent.prototype.onPageSwitch;
/**
 * @hidden
 * @type {?}
 */
CfDatatablePagerComponent.prototype._rowsCount;
/**
 * @hidden
 * @type {?}
 */
CfDatatablePagerComponent.prototype._perPage;
/**
 * @hidden
 * @type {?}
 */
CfDatatablePagerComponent.prototype._current;
/**
 * @hidden
 * @type {?}
 */
CfDatatablePagerComponent.prototype._pages;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
